import { z } from 'zod'

// Personal API keys (TO-516). Neither schema accepts a tenant or user: both
// come from the DB-resolved principal, never the body (ADR-0034).

const NAME_MAX_CODE_POINTS = 100

/** 1–100 Unicode code points after trimming (code points, not UTF-16 units). */
const apiKeyName = z
	.string()
	.trim()
	.refine((s) => s.length > 0, 'name must not be blank')
	.refine((s) => [...s].length <= NAME_MAX_CODE_POINTS, `name must be at most ${NAME_MAX_CODE_POINTS} characters`)

/**
 * `POST /users/me/api-keys`. A lifetime outside 1–90 whole days is refused
 * (422), never clamped; absent means 30.
 */
export const createApiKeySchema = z.object({
	name: apiKeyName,
	expiresInDays: z.number().int().min(1).max(90).default(30),
})

/** `PATCH /users/me/api-keys/{apiKeyId}` — the label only. */
export const renameApiKeySchema = z.object({ name: apiKeyName })

export type CreateApiKeyInput = z.infer<typeof createApiKeySchema>
export type RenameApiKeyInput = z.infer<typeof renameApiKeySchema>
